/** W9 Print GOT Sample (legacy QCS Utility, manual p209–210). */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { GotPrintSamplePage } from "@/features/got/components/print-sample-page";

const search = z.object({
  cropId: z.number().int().optional(),
  varietyId: z.number().int().optional(),
  lots: z.string().optional(),
  print: z.string().optional(),
});

export const Route = createFileRoute("/_app/quality/got/print-sample")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.print_sample"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <GotPrintSamplePage
      search={s}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
